module.exports = __webpack_public_path__ + "img/avatar.8645598c.png";